import { Reducer } from 'react';
import { handleActions } from 'redux-actions';
import {
    ACTION_CREATESTORE_SUCCESS,
    ACTION_UPDATESTORE_SUCCESS,
    ACTION_GETSTORELIST_SUCCESS,
    ACTION_GETSTORELISTBYSEARCH_SUCCESS,
    ACTION_OPERATESTORE_FAIL
} from '../../actions/scanner/store'

export interface storeState {
    storeList: any,
    storeListBySearch: any[],
    isSearch: boolean
    isSuccess: boolean,
    failData: string,
}

const defaultState: storeState = {
    storeList: {},
    storeListBySearch: [],
    isSearch: false,
    isSuccess: false,
    failData: ''
}

function handleActionGetStoreListSuccess(state: storeState, action): storeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        storeList: action.payload.data
    }
}

function handleActionGetStoreListBySearchSuccess(state: storeState, action): storeState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        storeListBySearch: action.payload.data,
        isSearch: action.payload.isSearch
    }
}

function handleActionUpdateStoreSucces(state: storeState, action): storeState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        isSuccess: true,
        failData: ''
    }
}

function handleActionCreateStoreSuccess(state: storeState, action): storeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: true,
        failData: ''
    }
}

function handleActionOperateStoreFail(state: storeState, action): storeState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        isSuccess: false,
        failData: action.payload.data
    }
}

export const storeReducer: Reducer<storeState, any> = handleActions(
    {
        [ACTION_GETSTORELIST_SUCCESS]: handleActionGetStoreListSuccess,
        [ACTION_CREATESTORE_SUCCESS]: handleActionCreateStoreSuccess,
        [ACTION_OPERATESTORE_FAIL]: handleActionOperateStoreFail,
        [ACTION_UPDATESTORE_SUCCESS]: handleActionUpdateStoreSucces,
        [ACTION_GETSTORELISTBYSEARCH_SUCCESS]: handleActionGetStoreListBySearchSuccess
    },
    defaultState
)